import { Accordion } from '@/shared/components/Accordion/Accordion';
import { RecommendationsAccordionStyle } from './Recommendations.styles';
import { useAccessibilityCheckerStore } from '@/stores/AccessibilityCheckerStore/AccessibilityCheckerStore';
import { StyledSeparator } from '@/shared/styles';
import { useTranslation } from 'react-i18next';
import { RecommendationContent } from './RecommendationContent';

export const Recommendations: React.FC = () => {
  const { recommendations } = useAccessibilityCheckerStore();
  const { t } = useTranslation();

  const getAccordionRows = () => {
    return [
      {
        title: t('free_tools.accessibility_checker.recommendations.title'),
        customContent: <RecommendationContent recommendations={recommendations} />,
      },
    ];
  };

  return (
    recommendations.length > 0 && (
      <>
        <StyledSeparator $width="100%" />
        <Accordion
          $accrodionRows={getAccordionRows()}
          $customStyle={RecommendationsAccordionStyle}
        />
      </>
    )
  );
};
